<div class="p-fluid p-grid">
  <div class="p-md-3 p-sm-12">
    <p-card header="Filtros" (keyup)="ds.onEnterSearch($event)">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
      </div>
      <div class="p-field">
        <label>Tópico:</label>
        <p-dropdown placeholder="Selecione..." [options]="topicoItens"
          [(ngModel)]="ds.restricoes.atributo('topico').valor" filter="true">
        </p-dropdown>
      </div>
      <div class="p-grid">
        <m-restricao-entidade label="Situação" [restricao]="ds.restricoes.atributo('situacao')" [itens]="situacaoItens" itemId="value" itemLabel="label"></m-restricao-entidade>
        <m-restricao-number label="Partição" [restricao]="ds.restricoes.atributo('particao')"></m-restricao-number>
        <m-restricao-string label="Conteúdo" [restricao]="ds.restricoes.atributo('conteudo')"></m-restricao-string>
        <m-restricao-temporal label="Auditoria data de inserção" [restricao]="ds.restricoes.atributo('auditoriaDataInsercao')"></m-restricao-temporal>
        <m-restricao-string label="Mensagem de erro" [restricao]="ds.restricoes.atributo('mensagemErro')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-col">
            <button pButton label="Pesquisar" (click)="ds.load()"></button>
          </div>
          <div class="p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.clearRestrictions()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-md-9 p-sm-12">
    <p-card header="Mensagens">
      <p-table [scrollable]="true" scrollHeight="700px" [virtualRowHeight]="40" [virtualScroll]="true"
        [value]="ds.entidades" (onLazyLoad)="ds.onLazyLoad($event)" [lazy]="true" [rows]="ds.rows" responsive="true"
        sortField="auditoriaData" dataKey="id" expandableRows="true">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-toggler"></th>
            <th class="col-mensagem" pSortableColumn="id">Mensagem <p-sortIcon field="id"></p-sortIcon></th>
            <th class="col-situacao">Situação</th>
            <th class="col-acao">Ação</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entity let-expanded="expanded">
          <tr *ngIf="entity !== undefined" style="height: 65px">
            <td class="col-toggler">
              <a href="#" [pRowToggler]="entity">
                <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
              </a>
            </td>
            <td class="col-mensagem">
              <div>{{entity.id}}</div>
              <div>{{entity.topico}}</div>
              <span class="label label-info margem-direita">
                Partição: {{entity?.particao}}
              </span>
            </td>
            <td class="col-situacao">
              <span [style.color]="getTipoSituacaoCor(entity.situacao)">{{getTipoSituacaoDescricao(entity.situacao)}}</span>
            </td>
            <td class="col-acao">
              <button
                pButton
                label="Executar"
                title="Executar novamente"
                (click)="executarNovamente(entity)">
              </button>
            </td>
          </tr>
          <tr *ngIf="entity === undefined" style="height: 65px">
            <td class="col-toggler"><div class="carregando-tabela"></div></td>
            <td class="col-mensagem"><div class="carregando-tabela"></div></td>
            <td class="col-situacao"><div class="carregando-tabela"></div></td>
            <td class="col-acao"><div class="carregando-tabela"></div></td>
          </tr>
        </ng-template>

        <ng-template let-entity pTemplate="rowexpansion">
          <tr>
            <td colspan="4">
              <div class="p-grid p-fluid">
                <div class="p-col-12 text-left m-l-10">
                  <h4>Conteúdo:</h4>
                  <textarea readonly rows="10" style="width:98%;">{{toJson(entity.conteudo) | json}}</textarea>
                  <h4 [style.color]="getTipoSituacaoCor(entity.situacao)">{{getTipoSituacaoDescricao(entity.situacao)}}</h4>
                  <div *ngIf="entity.situacao !== 'NAO_PROCESSADA'">
                    <strong>Data últ. tentativa:</strong> {{entity.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}<br />
                    <strong>Data inserção:</strong> {{entity.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}<br />
                    <strong>Mensagem de erro:</strong> {{entity.mensagemErro}}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr style="height: 700px">
            <td colspan="3"></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="summary">
          <div style="text-align: left">
            <button pButton label="Executar todos novamente" (click)="executarTodosNovamente(ds.entidades)"></button>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
